import gql from 'graphql-tag';

const query = gql`
  query CookbookMeals($searchCriteria: MealsSearchCriteriaInputType) {
    cookbook {
      meals(searchCriteria: $searchCriteria) {
        edges {
          node {
            id
            isFavorite
            name
            preparationImageUrl
            preparationTime {
              minutes
            }
            nutrition {
              singleServing {
                kcal
              }
            }
            tags {
              dietTypeTags {
                id
                name
              }
              mealTypeTags {
                id
                name
              }
              customTags {
                id
                name
                labelColor
              }
            }
            rating {
              averageRating {
                averageRating
              }
            }
            viewerAccess {
              canView
              canStart
              reason
            }
          }
        }
      }
    }
  }
`;

export default query;
